import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarIndexService {

  constructor(private http: HttpClient) { }

  listarCarIndex():Observable<any>{
    const params = new HttpParams().set('funcion', 'listarCarIndex');
    return this.http.get(`${environment.url.gestionSoporte}`, { params });
  }


  eliminarCarIndex(id_carindex: string):Observable<any>{
    const params = new HttpParams().set('funcion', 'eliminarCarIndex').set('id',id_carindex);
    return this.http.get(`${environment.url.gestionSoporte}`, { params });

  }

  habDesCarIndex(id_carindex: string, estadoMod: string):Observable<any> {
    const params = new HttpParams().set('funcion', 'habDesCarIndex').set('id',id_carindex).set('accion',estadoMod);
    return this.http.get(`${environment.url.gestionSoporte}`, { params });
  }

  guardarImagen(file: any):Observable<any> {
    const formData = new FormData();
    formData.set('imagen',file);
    const params = new HttpParams().set('funcion', 'guardarCardIndex');
    return this.http.post(`${environment.url.gestionSoporte}`,formData, { params });
  }

  listarCarIndexHab():Observable<any> {
    const params = new HttpParams().set('funcion', 'listarCarIndexHome');
    return this.http.get(`${environment.url.gestionSoporte}`, { params });
  }
}
